import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from "@angular/router";

import { SlimScrollOptions, Incident } from "app/shared/shared.module";
import { CaseService } from "app/case/case.service";

import { Location } from "app/common/location";
import { Subscription } from "rxjs/Subscription";
import { BusyLoaderService } from "app/shared/components/busy-loader.service";

@Component({
    selector: 'app-case-details-report',
	templateUrl: './case-details-report.component.html',
	styleUrls: ['./case-details-report.component.css']
})
export class CaseDetailsReportComponent implements OnInit {

    Today: Date = new Date();
    AllergyFilter: string = "";
    MedicinesFilter: string = "";

	ViewLocation: boolean = false;
	Location: Location = new Location({ Name: "default" });

	Case: Incident;
    SlimScrollOptions = SlimScrollOptions;

    sub: Subscription;
    GettingCase: Subscription;

    constructor(private caseService: CaseService, private route: ActivatedRoute, private busyLoaderService: BusyLoaderService) { }

    ngOnInit() {
        this.sub = this.route.parent.params.subscribe(params => {
            if (params && params['id']) {
                var ob = this.caseService.GetCaseDetails(params['id']);
                this.busyLoaderService.AddLoadingObservable(ob);
                this.GettingCase = ob.subscribe(
                    item => {
                        this.Case = item;
                    }, err => {
                        console.log(err);
                    }
                );
            }
        });
    }
    ngOnDestroy() {
        this.sub.unsubscribe();
        this.GettingCase.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/app/case/details/report/case-details-report.component.ts